import React from "react";
import { Container, Skeleton, Stack } from "@mui/material";

export function MobileView() {
    return <Container className="mobileView">
        <Skeleton height={170} variant="rectangular" className="imageSkeleton" />
        <Skeleton height={50} width={200} sx={{ mt: 1, mb: 2 }} />
        <Stack direction={'row'} spacing={1} alignItems="center" sx={{ mb: 2 }}>
            <Skeleton variant="circular" width={40} height={40} />
            <Skeleton width={200} height={30} />
        </Stack>
        <Skeleton height={10} />
        <Skeleton height={15} sx={{ mt: 1.5, mb: 1.5 }} />
        <Skeleton height={10} />
        <Skeleton height={40} sx={{ mt: 2, mb: 2 }} />
        {
            [...Array(3)].map(() => {
                return <Skeleton height={10} sx={{ mb: 1 }} />
            })
        }
    </Container>
}